module.exports = __webpack_public_path__ + "static/averta-semibold-webfont-67a3f8dc15f0e3b2e5a604fea6627d74.woff2";